<template>
  <div class="container">
    <div
      class="text-center h-full px-3 d-flex flex-column justify-content-center"
    >
      <v-icon icon="lock" class="text-grey-50" size="3rem" />
      <h2 class="mb-0">
        {{ $t("components.pageTemplates.genericTemplate.notAccessTitle") }}
      </h2>

      <template v-if="isPrivate">
        <p class="lead mt-2 mb-5">
          {{ $t("components.pageTemplates.genericTemplate.loginToHaveAccess") }}
        </p>
      </template>
      <template v-else-if="requiresPurchase">
        <p class="lead mt-2 mb-5">
          {{ $t("components.pageTemplates.genericTemplate.purchaseToUnlock") }}
        </p>
      </template>
      <template v-else-if="isScheduled">
        <p class="lead mt-2 mb-5">
          <template v-if="availableAfter">
            {{
              $t("components.pageTemplates.genericTemplate.availableIn", {
                in: timeAgo(availableAfter, true)
              })
            }}
          </template>
          <template v-else>
            {{ $t("components.pageTemplates.genericTemplate.notAvailable") }}
          </template>
        </p>
      </template>
      <template v-else>
        <p class="lead mt-2 mb-5">
          {{
            $t("components.pageTemplates.genericTemplate.loginToReviewContent")
          }}
        </p>
      </template>
      <v-button
        v-if="requiresPurchase"
        block
        @click="$emit('purchase')"
        class="mb-2"
      >
        {{ $t("components.pageTemplates.genericTemplate.purchase") }}
      </v-button>

      <v-button
        v-if="!isAuthenticated"
        secondary
        @click="() => $router.push('#auth')"
      >
        {{ $t("components.pageTemplates.genericTemplate.login") }}
      </v-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

import { timeAgo } from "@/lib/date-utils"
import { REASONS } from "@/lib/access/utils"

export default {
  props: {
    access: { type: Object, required: true }
  },

  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),

    isPrivate() {
      return this.access.reason === REASONS.IS_PRIVATE
    },

    requiresPurchase() {
      return this.access.reason === REASONS.REQUIRE_PURCHASE
    },

    isScheduled() {
      return this.access.reason === REASONS.IS_SCHEDULED
    },

    availableAfter() {
      return this.access.data?.available_after
    }
  },

  methods: {
    timeAgo
  }
}
</script>
